import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    row = "row",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.row]: string;
    };
}

export interface TeamRowStyles {
    row?: InjectableCss;
}

export const teamrowStyles: TeamRowStyles = {};

const styles = teamrowStyles;

type Props = OwnProps;

const TeamRow: FC<Props> = ({ id }) => {
    const RowStyles = {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: row;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-wrap: wrap;
                        `,
                    ],
                    "max",
                )}
            & > div {
                width: 100%;
                & :last-child {
                    padding-right: 0;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                flex-basis: 100%;
                            `,
                        ],
                        "max",
                    )}

                & > div {
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;
                }
            }
        `,
    };
    return (
        <StyledWrapper {...RowStyles}>
            <StyledWrapper {...styles.row}>
                <Zone contentId={id} zoneName="contentOne" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const teamrow: WidgetModule = {
    component: TeamRow,
    definition: {
        group: "Common",
        fieldDefinitions: [],
    },
};

export default teamrow;
